import { Barcode, Plus } from '@phosphor-icons/react';
import { Button, Flex } from 'antd';

/** Actions for the settings Warehouse tab (detail view). */
export function SettingsWarehouseToolbar({ onAddWarehouse, onGenerateLabel }) {
  return (
    <Flex justify="flex-end" align="center" gap={8} style={{ marginBottom: 12 }}>
      <Button type="primary" icon={<Plus size={16} />} onClick={onAddWarehouse}>
        Warehouse
      </Button>
      <Button icon={<Barcode size={16} />} onClick={onGenerateLabel}>
        Generate Location Label
      </Button>
    </Flex>
  );
}
